import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	loadingMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	loadingMessage: {
		id: 'jql-builder-basic-picker.async-select.menu-list.loading-message.loading-message',
		defaultMessage: 'Loading...',
		description: 'The text for when options are being loaded in dropdown',
	},
});
export default messages;
